"use client";

import clsx from "classnames";
import { Col, Container, Row } from "react-bootstrap";
import { Title } from "@/ui";
import classes from "./styles.module.scss";
import { useState } from "react";

export default function TileGrid({ sectionId, className, bgColor, title, titleColor, tabs }) {
  const [activeTab, setActiveTab] = useState(0);

  const currentItems = tabs?.[activeTab]?.items || [];

  return (
    <div id={sectionId} className={clsx(className, bgColor, classes.TileGrid)}>
      <Container>
        <Title title={title} className={clsx(titleColor, "mb-4")} />

        {/* Tabs Header */}
        <div className={classes.tabsWrapper}>
          {tabs?.map((tab, index) => (
            <button
              key={tab.title}
              onClick={() => setActiveTab(index)}
              className={clsx(classes.tabButton, index === activeTab && classes.active)}
            >
              {tab.title}
            </button>
          ))}
        </div>

        {/* Grid Items */}
        <Row>
          {currentItems.length > 0 ? (
            currentItems.map((item, index) => {
              const Wrapper = item?.href ? "a" : "div";

              return (
                <Col lg={3} md={6} key={index} className="my-3">
                  <Wrapper href={item?.href} className={classes.tile}>
                    <figure className="object_fit">
                      <img
                        src={item?.image?.url || "/assets/home/placeholder-image.jpeg"}
                        alt={item?.image?.alt || "Image"}
                        className="w-100"
                      />
                    </figure>

                    <div className={classes.tileTitle}>{item?.title}</div>
                  </Wrapper>
                </Col>
              );
            })
          ) : (
            <Col>
              <div className={classes.emptyState}>No items available</div>
            </Col>
          )}
        </Row>
      </Container>
    </div>
  );
}
